var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._m(0),_c('c-panel',[_c('situacao-academica')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('i',[_vm._v(" Atenção! Os alunos que já tiveram a sua matrícula renovada para o ano letivo de 2026, porém não foram aprovadas em 2025, você deverá realizar uma nova enturmação em 2026 por meio da coluna: "),_c('b',[_vm._v("Nova Enturmação em 2026")])])
}]

export { render, staticRenderFns }